import { render, staticRenderFns } from "./examRecord.vue?vue&type=template&id=52ef575e&scoped=true"
import script from "./examRecord.vue?vue&type=script&lang=js"
export * from "./examRecord.vue?vue&type=script&lang=js"
import style0 from "./examRecord.vue?vue&type=style&index=0&id=52ef575e&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ef575e",
  null
  
)

export default component.exports